import nxModule from 'nxModule';
import ParameterizedLocalCache from "../../shared/utils/parameterized-local-cache";

nxModule.factory('brisReportingTypesCache', (http, CacheFactory, config) =>
  new ParameterizedLocalCache({
    provider: (productGroup) => http.get(`/products/casa/bris-reporting-types/${productGroup}`),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.brisReportingTypes,
    cacheName: 'brisReportingTypes'
  })
);
